import { Component, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef, MatListOption } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { environment } from '../../../../../../../../environments/environment';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { DivisionService } from '../../../../../../services/divisions/division.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../../const/date-format';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'fuse-division-payment',
    templateUrl: './division-payment.component.html',
    styleUrls: ['./division-payment.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'es-AR'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class DivisionPaymentComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;
    public paymentSummary: any;

    public attrs = [];
    public shifts = [];

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    totalAmount: number = 0;

    maskedInputControllerTutorBirthdate;
    maskedInputControllerStudentBirthdate;

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    @ViewChild('tutorBirthdate', {read: ViewContainerRef}) public tutorBirthdate;
    @ViewChild('studentBirthdate', {read: ViewContainerRef}) public studentBirthdate;
    
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DivisionPaymentComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public divisionService: DivisionService,
        public datepipe: DatePipe,
    ) {
        console.log('FuseDivisionPaymentComponent > data', data);
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        this.data.paymentDate =this.datepipe.transform(this.data.paymentDate, 'yyyy-MM-dd');
        this.filters();
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }

    filters() {
        if (this.data.paymentDate == null) {
            return 0;
        }
        let tmp = this.datepipe.transform(this.data.paymentDate, 'yyyy-MM-dd');
        this.divisionService.getPaymentSummary(this.data.schoolYear, tmp).subscribe(response => {
            this.totalAmount = 0;
            this.blockUI.stop();
            console.log('SchoolDataComponent > ngOnInit > this.schooldataService.getdata()', response);
            this.paymentSummary = response;
        }, error => {
            this.blockUI.stop();
            this.sweetAlertService.error('Error', 'Ocurrio un error al traer los turnos.', null);
        });
    }

    selectionChange(option: MatListOption) {
        console.log(option.selected + "  " + option.value);
        if (option.selected) {
            this.totalAmount = this.totalAmount + option.value;
        } else {
            if (this.totalAmount > 0 ) {
                this.totalAmount = this.totalAmount - option.value;
            } else {
                this.totalAmount = 0;
            }
        }
    }

    save() {
        const attrs = this.attrs.filter(e => e.Checked).map(e => e.Code);
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        console.log('d', environment.backendUri + 'report/excel/student/' + attrs + '/' + shifts);
        window.open(environment.backendUri + 'report/excel/student/' + attrs + '/' + shifts, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/divisions-payments/division-payment.component.ts